import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { DrawerPrizes, PrizesDetailInfo } from 'widgets/prize';
import { UpdatePrizeForm } from 'entities/prize';

export const PrizesDetailPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Призы'));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return (
    <>
      <PrizesDetailInfo />
      <DrawerPrizes title="Изменение приза">
        <UpdatePrizeForm />
      </DrawerPrizes>
    </>
  );
};
